import { useState, useCallback, useContext } from 'react';
import EnvironmentVariableContext from '@ssg/common/EnvironmentVariableContext';
import { useMicrosoftAuth } from '@ssg/common/Components/MicrosoftAuth';
import { stringToByteArray } from '@ssg/common/Helpers/inputFileHelper';

interface UseUploadSignatureResult {
	isUploading: boolean;
	error: string | null;
	uploadSignature: (fileBase64: string, fileName: string, erpNumber: string) => Promise<Response | undefined>;
}

export function useUploadSignature(): UseUploadSignatureResult {
	const [isUploading, setIsUploading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const envVar = useContext(EnvironmentVariableContext);
	const { getTokens } = useMicrosoftAuth();

	const uploadSignature = async (fileBase64: string, fileName: string, erpNumber: string) => {
		setIsUploading(true);
		setError(null);
		try {
			const { appToken } = await getTokens();
			const formData = new FormData();
			const fileAsBytes = stringToByteArray(fileBase64);
			const byteArray = new Uint8Array(fileAsBytes);
			const blob = new Blob([byteArray], { type: 'image/png' });
			formData.append('file', blob, fileName);
			formData.append('folderName', erpNumber);
			formData.append('fileName', fileName);
			formData.append('metadata', 'IsHiddenForExternal');

			const response = await fetch(envVar.baseUrl + '/api/upload/uploadCaseFile', {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${appToken}`,
				},
				body: formData,
			});
			return response;
		} catch (err: any) {
			setError(err.message || 'Upload failed');
			throw err;
		} finally {
			setIsUploading(false);
		}
	};
	return {
		isUploading,
		error,
		uploadSignature,
	};
}
